module.exports = __webpack_public_path__ + "img/zuil.7408537f.jpg";